import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';
import {auth, withState, t} from 'shared/core';
import {OutOfOfficeState} from '../state';
import {Panel, Avatar, EmojiTitle} from 'components';
import {dateSpan} from 'shared/tools';
import Table from 'components/tables/components/Table';

const LOCALIZATION = {
  emptyState: 'hr_dashboard.out_of_office.Nobody is off today',
};

const ConcurrentRequestDetails = observer(({timeOffRequest}) => {
  const {employee} = timeOffRequest;

  return (
    <div className='flex'>
      <Avatar size='sm' employee={employee} />
      <div className='ml2 flex-grow'>
        <span>{`${employee.firstName} ${employee.lastName}`}</span>
        <div className='OutOfOffice'>
          {auth.company.peopleOffTodayVisibility && timeOffRequest.timeOffType && <span className='people-off-today info'>
            {`${timeOffRequest.timeOffType.name} ${timeOffRequest.todaysAbsenceDuration === '0.0' ? '' : `(${timeOffRequest.todaysAbsenceDurationFormatted})`}`}
          </span>}
          <span className='people-off-today info'>{`${dateSpan(timeOffRequest.startDate, timeOffRequest.endDate)}`}</span>
        </div>
      </div>
    </div>
  );
});

const COLUMNS = [
  {
    width: 12,
    render: model => <ConcurrentRequestDetails timeOffRequest={model} />
  }
];

const OutOfOffice = observer(({uiState}) => {
  const {ptoRequests, Emoji} = uiState;

  return (
    <Panel>
      <Panel.Header title={<EmojiTitle Emoji={Emoji} emojiKey='airplane' title={t('hr_dashboard.out_of_office.People Off Today')}/>}/>
      <Table
        localization={LOCALIZATION}
        columns={COLUMNS}
        models={ptoRequests}
        showHeaders={false}
        showLinks={false}
        uiState={uiState}
      />
    </Panel>
  );
});

export default withState(OutOfOffice, OutOfOfficeState);
